import moment from 'moment'

moment.locale('pt-br')

const GENDER = {
  'MALE': 'Masculino',
  'FEMALE': 'Feminino'
}

export function currency (value) {
  let formatted = parseFloat(`${value}`)
    .toFixed(2)
    .replace(/\./g, ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  return `R$ ${formatted}`
}

export function number (value) {
  return `${value}`.length === 1 ? `0${value}` : value
}

export function simpledate (value) {
  return moment(value).format('L')
}

export function date (value) {
  return moment(value, 'DDMMYYYY').format('DD/MM/YYYY')
}

export function formatHours (value) {
  return moment(value, 'HH:mm:ss').format('HH:mm')
}

export function dateBirth (value) {
  return moment(value, 'DDMMYYYY').format('YYYY-MM-DD')
}

export function date8601 (value) {
  return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
}

export function postalCode (value) {
  return value.replace(/(\d{5})(\d{3})/g, '$1-$2')
}

export function document (value) {
  return value.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
}

export function gender (value) {
  return GENDER[value]
}

export function phone (value) {
  return `${value}`.replace(/(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3')
}

export function capitalize (value) {
  return value.replace(/(^|\s)\w{1}/g, l => l.toUpperCase())
}

export function points (value) {
  return Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export function clubeLiveloPoints (points) {
  return parseInt(points / 10 * 15)
}
